module.exports = __webpack_public_path__ + "btn-sing-cover.8a4527fa.png";